export default "__VITE_ASSET__CyDfoAYN__"